// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import UserInfoFooter from '../../../../views/user-info/user-info-footer';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const navItems =
        menuItem.items.map((item, index) => {
            switch (item.type) {
                case 'group':
                    return (
                        <div key={item.id}>
                            <NavGroup item={item} />
                            <UserInfoFooter />
                        </div>
                    );
                default:
                    return (
                        <Typography key={item.id || `error-${index}`} variant="h6" color="error" align="center">
                            Menu Items Error
                        </Typography>
                    );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;